import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ClientNameService } from '@sharedModule/services/clientName/client-name.service';

export const clientNameGuard: CanActivateChildFn = (
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const clientNameService = inject(ClientNameService);
 const cachedName = clientNameService.getCachedClientName();
 
  const regex = /^\/(undefined|null|clientName)(\/.*)?$/;
    if (regex.test(state.url)) {
      const newUrl = state.url.replace(
        regex,
        `/${cachedName}$2`
      );
    inject(Router).navigateByUrl(newUrl);
    return false;
    }    
    return true; // Allow navigation
  
};
